import Vue from 'vue'
import Vuex from 'vuex'
import rootUrl from '../rootUrl'
import subscriptions from './subscriptions'
import newSubscriptionForm from './newSubscriptionForm'
import users from './users'
import newUserForm from './newUserForm'
import editUserForm from './editUserForm'
import notification from './notification'
import loginAsUser from './loginAsUser'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    subscriptions,
    newSubscriptionForm,
    users,
    newUserForm,
    editUserForm,
    notification,
    loginAsUser
  }
})